export const langSpeedList = {
  fr: {
    title: 'Max 5 vitesse GPS',
    time: 'Heure',
    speed: 'Vitesse (knt)',
  },
  eng: {
    title: 'Max 5 GPS speed',
    time: 'Time',
    speed: 'Speed (knt)',
  },
}
